import { defineStore } from 'pinia'
import { getAccessTokenSilentlyOutsideComponent } from '@/main.js'
import { ref, computed } from 'vue'

export const useUserStore = defineStore('user', () => {

  const user = ref(null)
  const name = computed(() => user.value?.name)
  const email = computed(() => user.value?.email)
  const id = computed(() => user.value?.id)
  async function retrieveProfile() {
    const token = await getAccessTokenSilentlyOutsideComponent()

      if(!token){
        return;
      }

      const response = await fetch(`https://${import.meta.env.VITE_AUTH0_DOMAIN}/userinfo`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      user.value = {
        name: data.name,
        email: data.email,
        id: data.sub
    }
  }

  return {
    user,
    name,
    email,
    id,
    retrieveProfile
  }
})